// src/styles/themes/defaultTheme.js
export const defaultTheme = {
  name: 'default',
  colors: {
    primary: '#00823C',
    secondary: '#4CAF50',
    accent: '#28a745',
    danger: '#a4262c',     // or 'rgb(164, 38, 44)' for light
    white: '#ffffff',      // white for text
    background: 'rgb(243, 242, 241)',
    card: 'rgb(255, 255, 255)',
    text: 'rgb(50, 49, 48)',
    blankandwhite: "rgb(50, 49, 48)",
    whiteandblack: "#fff",
    textSecondary: 'rgb(96, 94, 92)',
    border: 'rgb(237, 235, 233)',
    success: 'rgb(16, 124, 16)',
    danger: 'rgb(164, 38, 44)',
    warning: 'rgb(249, 200, 49)',
    lightGray: 'rgb(243, 242, 241)',
    selected: '#d0ebff',
    selectedOption: "#d0f0dc",
    button: '#00823C',
    buttonText: '#fff',
    disabledBackground: "#E0E0E0",

    // Added theme-based extensions
    inputBorder: '#dee2e6',
    hoverBorder: '#6ea8fe',
    hoverBackground: '#f8f9fa',
    focusBorder: '#4a90e2',
    focusShadow: 'rgba(74, 144, 226, 0.5)',
    focusRing: 'rgba(13, 110, 253, 0.15)',
    cardHeader: '#f8f9fa',
    cardFooter: '#f8f9fa',
    emptyBackground: '#f9f9f9',
    text: '#323130',
    focusBorder: '#4a90e2',
    focusShadow: 'rgba(74, 144, 226, 0.5)',
    auditbadge: "#f0f0f0",
    auditbadgecolor: "#333"
  },
  fonts: {
    primary: '"Segoe UI", "Helvetica Neue", sans-serif',
    secondary: '"Segoe UI", "Helvetica Neue", sans-serif',
  },
  shadows: {
    small: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.13), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.11)',
    medium: '0 3.2px 7.2px 0 rgba(0, 0, 0, 0.13), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.11)',
    large: '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.13), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.11)',
  },
  transitions: {
    fast: '0.1s ease',
    medium: '0.2s ease',
    slow: '0.4s ease',
  },
  borderRadius: {
    small: '2px',
    medium: '3px',
    large: '4px',
    full: '50%',
  },
};

export const darkTheme = {
  ...defaultTheme,
  name: 'dark',
  colors: {
    ...defaultTheme.colors,
    /** Brand Colors (unchanged) */
    primary: '#00823C',
    secondary: '#66BB6A',
    accent: '#28a745',
    blankandwhite: "#fff",
    whiteandblack: "rgb(50, 49, 48)",
    /** Backgrounds */
    background: '#1e1e1e',              // Main background
    card: '#2a2a2a',                    // Card surface
    danger: '#ff4d4f',       // brighter for visibility on dark background
    white: '#ffffff',
    lightGray: '#383838',              // For sections/light borders
    selected: '#333c4a',               // Used for row selection
    selectedOption: "#d0f0dc",
    /** Text */
    text: '#ffffff',                   // Main text
    textSecondary: '#cccccc',          // Subtext, descriptions

    /** Borders & Inputs */
    border: '#3c3c3c',                 // General borders
    inputBorder: '#dee2e6',            // Inputs, selects, etc.
    hoverBorder: '#28a745',            // Focus/hover input border
    hoverBackground: '#2e2e2e',        // Light hover bg
    focusBorder: '#28a745',            // Focused field border
    focusShadow: 'rgba(40, 200, 100, 0.5)', // Input shadow
    focusRing: 'rgba(40, 200, 100, 0.15)', // Focus ring outline

    /** Alerts & State */
    success: '#52c41a',
    danger: '#ff4d4f',
    warning: '#faad14',

    /** Buttons */
    button: '#00823C',
    buttonText: '#ffffff',
    emptyBackground: '#2e2e2e',
    text: '#ffffff',
    focusBorder: '#28a745',
    focusShadow: 'rgba(40, 200, 100, 0.5)',
    auditbadge: "#2b2b2b",
    auditbadgecolor: "#ddd",
    disabledBackground: "#2D2D2D",
  },
};

export const lightTheme = {
  ...defaultTheme,
  name: 'light',
  colors: {
    ...defaultTheme.colors,
    background: 'rgb(255, 255, 255)',
    card: 'rgb(250, 250, 250)',
  },
};
